import React, { useRef, useState } from "react";
import Link from "next/link";
import classNames from "classnames";
import { useOutsideClick } from "@shared/lib/hooks/useOutsideClick";
import { ExpandIcon } from "@shared/ui/Icon/ui/Common/ExpandIcon";
import { mobileMenuItems } from "./config";
import { MobileMenuProps } from "./types";
import classes from "./mobile-menu.module.scss";

export const MobileMenu = ({ activeItem, className }: MobileMenuProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const ref = useRef<HTMLDivElement>(null);
    const ActiveIcon = activeItem.icon;

    useOutsideClick(ref, () => {
        if (isExpanded) {
            setIsExpanded(false);
        }
    });

    return (
        <div ref={ref} className={classNames(classes["mobile-menu"], className)}>
            <button
                type="button"
                className={classes["mobile-menu__toggle"]}
                onClick={() => setIsExpanded(!isExpanded)}
                aria-expanded={isExpanded}
            >
                <div className={classes["mobile-menu__current"]}>
                    <ActiveIcon />
                    <span>{activeItem.title}</span>
                </div>
                <ExpandIcon />
            </button>
            {isExpanded && (
                <nav className={classes["mobile-menu__nav"]}>
                    <ul className={classes["mobile-menu__list"]}>
                        {mobileMenuItems.map(({ title, link, Icon }) => (
                            <li key={link} className={classes["mobile-menu__item"]}>
                                <Link
                                    href={link}
                                    className={classNames(classes["mobile-menu__link"], {
                                        [classes["mobile-menu__link--active"]]:
                                            activeItem.link === link
                                    })}
                                >
                                    <Icon />
                                    <span>{title}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
            )}
        </div>
    );
};